module.exports = __webpack_public_path__ + "img/logo_tengxun.191d84cd.png";